import { useState } from "react";
import { AlertTriangle } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/primitives/button";
import { useSubscriptionState } from "@/zustand/SubscriptionState";
import { createPortalSession } from "@/server/services/stripeService";
import { toast } from "@/hooks/useToast";

/**
 * Globally visible warning banner shown when subscription.status === 'past_due'.
 * Links the user to the Stripe customer portal to update their payment method.
 */
export default function PastDueBanner() {
  const { t } = useTranslation();
  const status = useSubscriptionState((s) => s.subscription.status);
  const [loading, setLoading] = useState(false);

  if (status !== "past_due") {
    return null;
  }

  const handlePortal = async () => {
    setLoading(true);
    try {
      const url = await createPortalSession();
      window.location.href = url;
    } catch {
      toast({
        description: t("subscription.checkoutError"),
        variant: "destructive",
        duration: 3000,
      });
      setLoading(false);
    }
  };

  return (
    <div className="flex items-center justify-between gap-3 bg-destructive/10 px-4 py-2 text-sm text-destructive">
      <div className="flex items-center gap-2">
        <AlertTriangle className="size-4 shrink-0" />
        <span>
          <span className="font-semibold">
            {t("subscription.pastDueTitle")}
          </span>{" "}
          {t("subscription.pastDueDescription")}
        </span>
      </div>
      <Button
        variant="destructive"
        size="sm"
        className="shrink-0"
        disabled={loading}
        onClick={handlePortal}
      >
        {t("subscription.updatePaymentMethod")}
      </Button>
    </div>
  );
}
